import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { OAuthService } from "angular-oauth2-oidc";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { first } from "rxjs/operators";
import { lastValueFrom } from "rxjs";
import { Claims } from "src/app/_models/common/claims";
import {
  CurrencyInfo,
  MileageInfo,
  OrganisationBasicSetup,
  OrganisationBasicSetupRequestInfo,
  Profileinfo,
  SetupInfo,
} from "src/app/_models/user/userrequestdto";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/app/_services";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { VersionHistoryService } from "src/app/_services/common/version-history.service";
import { EMAIL_REGEX } from "src/util/constants";
import { ButtonComponent } from "../../../shared/design-system/button/button.component";
import { TextboxComponent } from "../../../shared/design-system/textbox/textbox.component";
import { InfoTextComponent } from "../../../shared/design-system/info-text/info-text.component";
import { ICONS } from "../../../_helpers/icons.constants";
import { TextboxConfig } from "../../../shared/design-system/textbox/textbox.modal";
import { ButtonConfig } from "../../../shared/design-system/button/button.modal";
import { InfoTextConfig } from "../../../shared/design-system/info-text/info-text.modal";

@Component({
    selector: "app-invite-employees",
    templateUrl: "./invite-employees.component.html",
    standalone: true,
    imports: [CommonModule, TranslateModule, FormsModule, TextboxComponent, ButtonComponent, InfoTextComponent]
})
export class InviteEmployeesComponent implements OnInit {
  @Output() gotoNextStepEvent = new EventEmitter<any>();
  firstnameConfig!: TextboxConfig;
  lastnameConfig!: TextboxConfig;
  emailConfig!: TextboxConfig;
  firstAccnameConfig!: TextboxConfig;
  lastaccnameConfig!: TextboxConfig;
  emailaccConfig!: TextboxConfig;
  addEmployeeConfig!: ButtonConfig;
  continueConfig!: ButtonConfig;
  skipConfig!: ButtonConfig;
  isSubmitting: boolean = false;

  public ICONS = ICONS;
  currentEmployee = {
    firstName: '',
    lastName: '',
    email: '',
    isExpanded: true,
    isInvalidEmail: false,
    isRequired: false
  };

  invitedEmployees: Array<{
    firstName: string;
    lastName: string;
    email: string;
    isExpanded: boolean;
    isInvalidEmail: boolean;
    isRequired: boolean;
  }> = [];
  isEnableInvite: boolean = false;
  maxEmployees = 2;
  claims: Claims;
  organisationBasicSetup: OrganisationBasicSetup;
  approverName: string;
  currentEmpFN: string = '';
  currentEmpLN: string = '';
  currentEmpEmail: string = '';
  accEmpFN: string = '';
  accEmpLN: string = '';
  accEmpEmail: string = '';
  isContinueDisabled: boolean = true;
  IsInviteCanBeDisabled = false;  
  nameMaxLength: string = "30";
  emailMaxLength: string = "100";
  
  constructor(
    private claimsService: ClaimsService,
    private ngxService: NgxUiLoaderService,
    private oauthService: OAuthService,
    private versionHistoryService: VersionHistoryService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private translate: TranslateService
  ) {
    this.organisationBasicSetup = new OrganisationBasicSetup();
    this.claimsService.currentClaims.subscribe(
      (claims: any) => (this.claims = claims)
    );
  }

  ngOnInit(): void {
    this.bindVersionHistory();


    this.firstnameConfig = {
      id:'first-name-input',
      label: this.translate.instant('label_first_name'),
      value: this.currentEmployee.firstName,
      required: true,
      placeholder: this.translate.instant('e.g. John'),
      maxLength: this.nameMaxLength,
      type: "text",
      size: "lg"
    };

    this.lastnameConfig = {
      id: 'last-name-input',
      label: this.translate.instant('label_last_name'),
      value: this.currentEmployee.lastName,
      placeholder: this.translate.instant('e.g. Doe'),
      maxLength: this.nameMaxLength,
      type: "text",
      size: "lg"
    };

    this.emailConfig = {
      id: 'email-input',
      label: this.translate.instant('email_label'),
      value: this.currentEmployee.email,
      required: true,
      isInvalid: !!this.currentEmpEmail,
      maxLength: this.emailMaxLength,
      helperText: this.currentEmpEmail,
      placeholder: this.translate.instant('email_placeholder'),
      type: "email",
      size: "lg"
    };
    this.firstAccnameConfig = {
      id: 'first-name-accordion-',
      label:this.translate.instant('label_first_name'),
      required:true,
      value: this.currentEmployee.firstName,
      isInvalid: !!this.accEmpFN,
      helperText: this.accEmpFN,
      placeholder: this.translate.instant('e.g. John'),
      type: "text",
      maxLength: this.nameMaxLength,
      size: "lg"
    };
    this.lastaccnameConfig = {
      id: 'last-name-accordion-',
      label:this.translate.instant('label_last_name'),
      value: this.currentEmployee.lastName,
      isInvalid: !!this.accEmpLN,
      helperText: this.accEmpLN,
      placeholder: this.translate.instant('e.g. Doe'),
      type: "text",
      maxLength: this.nameMaxLength,
      size: "lg"
    };
    this.emailaccConfig = {
      id: 'email-accordion-',
      label: this.translate.instant('email_label'),
      value: this.currentEmployee.email,
      required: true,
      isInvalid: !!this.accEmpEmail,
      helperText: this.accEmpEmail,
      placeholder: this.translate.instant('email_placeholder'),
      type: "email",
      maxLength: this.emailMaxLength,
      size: "lg"
    };
    this.setButtonConfigs();
  }


  setButtonConfigs() {
    this.addEmployeeConfig = {
      id:'add-another-employee-btn',
      label: this.translate.instant('add_another_employee'),
      color: "primary",
      size: "lg",
      disabled: this.isEnableInvite,
      block: true,
      ariaLabel: this.translate.instant('add_another_employee')
    };
    this.continueConfig = {
      id: 'continue-button',
      label: this.translate.instant('continue'),
      color: "primary",
      size: "lg",
      disabled: this.isContinueDisabled || this.IsInviteCanBeDisabled,
      block: true,
      ariaLabel: this.translate.instant('continue')
    };
    this.skipConfig = {
      id: 'skip-button',
      label: this.translate.instant('skip_for_now'),
      color: "primary-outline",
      size: "lg",
      block: true,
      ariaLabel: this.translate.instant('skip_for_now')
    };
  }

  canInviteMore(): boolean {
    if(this.currentEmployee.isExpanded){
      this.isEnableInvite = !this.currentEmployee.isExpanded || this.currentEmployee.firstName.trim() === '' || this.currentEmployee.email.trim() === '';
      this.addEmployeeConfig={
        ...this.addEmployeeConfig,
        disabled: this.isSubmitting || this.isEnableInvite
      };
   }
    else {
      this.isEnableInvite = this.invitedEmployees?.some(emp => !emp.firstName || !emp.email);
      this.addEmployeeConfig={
        ...this.addEmployeeConfig,
        disabled: this.isSubmitting || this.isEnableInvite
      };
    }
    if(this.invitedEmployees.length == 3) return false;
    return this.invitedEmployees.length < this.maxEmployees || !this.currentEmployee.isExpanded;
  }

  isExtendedFormValid(): boolean {
    let isValid = true;
    this.invitedEmployees.forEach(emp => {
      if (emp.isExpanded && !EMAIL_REGEX.test(emp.email)) {
        isValid = false;
        this.accEmpEmail = this.translate.instant('label_Emailisnotvalid');
        this.emailaccConfig = {
          ...this.emailaccConfig,
          isInvalid: true,
          helperText: this.accEmpEmail
        };
      }
      if (emp.email == this.claims.EmailId) {
        this.accEmpEmail = this.translate.instant('use_other_than_registered_email');
        this.emailaccConfig = {
          ...this.emailaccConfig,
          isInvalid: true,
          helperText: this.accEmpEmail
        };
        isValid = false;
      }
      if(this.invitedEmployees.filter(e => e.email.trim().toLowerCase() === emp.email.trim().toLowerCase()).length > 1){
        this.accEmpEmail = this.translate.instant('label_Duplicateemailaddress');
        this.emailaccConfig = {
          ...this.emailaccConfig,
          isInvalid: true,
          helperText: this.accEmpEmail
        };
        isValid = false;
      }
    });
    return isValid;
  }

  isCurrentFormValid(): boolean {
    if (!EMAIL_REGEX.test(this.currentEmployee.email)) {
      this.currentEmpEmail = this.translate.instant('label_Emailisnotvalid');
      this.emailConfig = {
        ...this.emailConfig,
        isInvalid: true,
        helperText: this.currentEmpEmail
      };
      return false;
    }
    if (this.currentEmployee.email == this.claims.EmailId) {
      this.currentEmpEmail = this.translate.instant('use_other_than_registered_email');
      this.emailConfig = {
        ...this.emailConfig,
        isInvalid: true,
        helperText: this.currentEmpEmail
      };
      return false;
    }
    if((this.invitedEmployees?.some(emp => emp.email.trim().toLowerCase() === this.currentEmployee.email.trim().toLowerCase()))){
      this.currentEmpEmail = this.translate.instant('label_Duplicateemailaddress');
      this.emailConfig = {
        ...this.emailConfig,
        isInvalid: true,
        helperText: this.currentEmpEmail
      };
      return false;
    }
    return true;
  }

  onInviteEmployee() {
    if (!this.isAnyAccordionExpanded() && !this.isCurrentFormValid()) {
      return;
    }
    if(this.isAnyAccordionExpanded() && !this.isExtendedFormValid()){
      return;
    }
    const emailLower = this.currentEmployee.email.trim().toLowerCase();
    const exists = this.invitedEmployees.some(emp => emp.email.trim().toLowerCase() === emailLower);
    if(!exists && (this.currentEmployee.firstName || this.currentEmployee.email)){ 
    this.invitedEmployees.push({
      firstName: this.currentEmployee.firstName,
      lastName: this.currentEmployee.lastName,
      email: this.currentEmployee.email,
      isExpanded: false,
      isInvalidEmail: false,
      isRequired: false
    });
  }
  else
    {this.invitedEmployees.forEach((emp, i) => {
        emp.isExpanded = false;
    });}
    this.currentEmployee = {
      firstName: '',
      lastName: '',
      email: '',
      isExpanded: true,
      isInvalidEmail: false,
      isRequired: false
    };
    this.firstnameConfig = {
      ...this.firstnameConfig,
      value: ''
    };
    this.lastnameConfig = {
      ...this.lastnameConfig,
      value: ''
    };
    this.emailConfig = {
      ...this.emailConfig,
      isInvalid: false,
      helperText: '',
      value: ''
    };
    this.isContinueDisabledFunc();
  }


  onCurrentChange(value: string, type?: string) {
    if(type === 'first-name'){
      this.currentEmployee.firstName = value;
      this.firstnameConfig = {
        ...this.firstnameConfig,
        value: value,
      }      
    }
    else if(type === 'last-name'){
      this.currentEmployee.lastName = value;
        this.lastnameConfig = {
          ...this.lastnameConfig,
          value: value,
      } 
    }  
    else if(type === 'email'){
      this.currentEmployee.email = value;
      this.accEmpEmail = '';
        this.emailConfig = {
          ...this.emailConfig,
          helperText: '',
          isInvalid: false,
          value: value,
      } 
    }
    if(this.currentEmployee.firstName && this.currentEmployee.email){
      this.addEmployeeConfig={
        ...this.addEmployeeConfig,
        disabled: false
      };
    }
    this.isContinueDisabledFunc();
  }

  onAccordionTextboxChange(value: string, type: string, index: number) {
    if(type === 'firstName'){
      this.invitedEmployees[index].firstName = value;
      this.firstAccnameConfig = {
        ...this.firstAccnameConfig,
        value: value,
      }      
    }
    else if(type === 'lastName'){
      this.invitedEmployees[index].lastName = value;
        this.lastaccnameConfig = {  
          ...this.lastaccnameConfig,
          value: value,
      }
    }
    else if(type === 'email'){
      this.invitedEmployees[index].email = value;
      this.accEmpEmail = '';
        this.emailaccConfig = {
          ...this.emailaccConfig,
          helperText: '',
          isInvalid: false,
          value: value,
      }
    }
    this.isContinueDisabledFunc();
  }
  isContinueDisabledFunc() {
    // Never re-enable Continue while a save/validation round-trip is in flight —
    // this method is also reached from OnInviteClick() via onInviteEmployee().
    if (!this.isSubmitting) {
      this.IsInviteCanBeDisabled = false;
    }
    // Continue is enabled once at least 1 employee (max 3) is provided.
    const validInvited = this.invitedEmployees.filter(e => e.firstName && e.email).length;
    const hasCurrent = !!(this.currentEmployee.firstName && this.currentEmployee.email);
    this.isContinueDisabled = (validInvited + (hasCurrent ? 1 : 0)) < 1;
    this.continueConfig = {
      ...this.continueConfig,
      disabled: this.isSubmitting || this.isContinueDisabled || this.IsInviteCanBeDisabled,
    };
  }

  toggleAccordion(index: number): void {
    if(this.accEmpEmail === this.translate.instant('claimant_exists')){
      return
    }
    if(this.isAnyAccordionExpanded() && !this.isExtendedFormValid()){
      return;
    }
    this.firstAccnameConfig = {
      ...this.firstAccnameConfig,
      id: 'first-name-accordion-' + index,
      value: this.invitedEmployees[index].firstName,
      helperText: '',
      isInvalid: false
    };
    this.lastaccnameConfig = {
      ...this.lastaccnameConfig,
      id: 'last-name-accordion-' + index,
      value: this.invitedEmployees[index].lastName,
      helperText: '',
      isInvalid: false
    };
    this.emailaccConfig = {
      ...this.emailaccConfig,
      id: 'email-accordion-' + index,
      value: this.invitedEmployees[index].email,
    };
    

    this.currentEmployee.isExpanded = false;
    if(this.currentEmployee.firstName || this.currentEmployee.email){
      if (!this.isCurrentFormValid()) {
        this.currentEmployee.isExpanded = true;
        return;
      }
      this.onInviteEmployee();      
      this.currentEmployee.isExpanded = false;
    }
    this.invitedEmployees.forEach((emp, i) => {
      if (i !== index) {
        emp.isExpanded = false;
      }
    });
    this.invitedEmployees[index].isExpanded = !this.invitedEmployees[index].isExpanded;
  }

  isAnyAccordionExpanded(): boolean {
    return this.invitedEmployees?.some(emp => emp.isExpanded);
  }

  async OnInviteClick() {
    // Re-entrancy guard: the awaited validation below leaves a window in which a
    // second click would submit the setup twice and create duplicate invites.
    if (this.isSubmitting || this.isContinueDisabled) return;
    this.IsInviteCanBeDisabled = true;
    this.fnSetSubmitting(true);
    const currentHasData = !!(this.currentEmployee.firstName || this.currentEmployee.email);
    if(currentHasData){
      let currentValid = true;
      if(!this.currentEmployee.firstName){
        currentValid = false;
        this.currentEmpFN = this.translate.instant('this_field_is_required');
        this.firstnameConfig = { ...this.firstnameConfig, isInvalid: true, helperText: this.currentEmpFN };
      }
      if(!this.isCurrentFormValid()){
        currentValid = false;
      }
      if(!currentValid){
        this.fnReleaseSubmitting();
        return;
      }
      if(this.invitedEmployees.length < 3){
        this.onInviteEmployee();
      }
    }
    if(this.isAnyAccordionExpanded() && !this.isExtendedFormValid()){
      this.fnReleaseSubmitting();
      return;
    }
    // At least 1 employee is required when using Continue (use Skip to invite none).
    if(this.invitedEmployees.length < 1){
      this.fnReleaseSubmitting();
      return;
    }
    this.ngxService.start();
    const isValid = await this.validateAllInvitesWithObjects();
    if (!isValid) {
      this.ngxService.stop();
      this.fnReleaseSubmitting();
      return;
    }
    this.submitOrganisationSetup();
  }

  onSkip() {
    if (this.isSubmitting) return;
    this.fnSetSubmitting(true);
    // Skip inviting anyone — submit with a blank invite array.
    this.invitedEmployees = [];
    this.currentEmployee = {
      firstName: '',
      lastName: '',
      email: '',
      isExpanded: true,
      isInvalidEmail: false,
      isRequired: false
    };
    this.ngxService.start();
    this.submitOrganisationSetup();
  }

  /** Disable (or restore) all 3 action buttons while the save API is in flight. */
  private fnSetSubmitting(submitting: boolean) {
    this.isSubmitting = submitting;
    this.addEmployeeConfig = { ...this.addEmployeeConfig, disabled: submitting || this.isEnableInvite };
    this.continueConfig = { ...this.continueConfig, disabled: submitting || this.isContinueDisabled || this.IsInviteCanBeDisabled };
    this.skipConfig = { ...this.skipConfig, disabled: submitting };
  }

  /** Re-enable the action buttons after a Continue attempt that never reached the API. */
  private fnReleaseSubmitting() {
    this.IsInviteCanBeDisabled = false;
    this.fnSetSubmitting(false);
  }

  submitOrganisationSetup() {
    this.fnSetSubmitting(true);
    this.organisationBasicSetup.RequestId = "111";
    this.organisationBasicSetup.WebApiName = "OrganisationBasicSetup";
    this.organisationBasicSetup.WebApiVersion = 1;
    this.organisationBasicSetup.RequestInfo = new OrganisationBasicSetupRequestInfo();
    this.organisationBasicSetup.RequestInfo.languageCode = "en-US";
    this.organisationBasicSetup.RequestInfo.loginId = this.claims.LoginId;
    this.organisationBasicSetup.RequestInfo.platform = 0;
    this.organisationBasicSetup.RequestInfo.userId =this.claims.UserId.toString();
    this.organisationBasicSetup.RequestInfo.setUpInfo = new SetupInfo();
    this.organisationBasicSetup.RequestInfo.setUpInfo.currencyInfo =new CurrencyInfo();
    this.organisationBasicSetup.RequestInfo.setUpInfo.currencyInfo.countryId =this.claims.SelectedCountry;
    this.organisationBasicSetup.RequestInfo.setUpInfo.currencyInfo.countryName =this.claims.SelectedCountryName;
    this.organisationBasicSetup.RequestInfo.setUpInfo.currencyInfo.currencyCode = this.claims.SelectedCurrencyCode;
    this.organisationBasicSetup.RequestInfo.setUpInfo.currencyInfo.currencyName = this.claims.SelectedCurrencyName;
    this.organisationBasicSetup.RequestInfo.setUpInfo.currencyInfo.currencyId = Number(this.claims.SelectedCurrency);
    this.organisationBasicSetup.RequestInfo.setUpInfo.inviteInfo = new Array();
    this.invitedEmployees.forEach((emp, index) => {
      this.organisationBasicSetup.RequestInfo.setUpInfo.inviteInfo.push({
        firstName: emp.firstName,
        lastName: emp.lastName === undefined ? "" : emp.lastName,
        email: emp.email,
        roleId: index === 0 ? 2 : 1,
        vehicleType: 1,
      });
    });
    this.approverName = this.invitedEmployees.length > 0
      ? this.invitedEmployees[0].firstName + " " + (this.invitedEmployees[0].lastName || "")
      : "";
    this.claims.EmployeesInvited = this.invitedEmployees.length;
    this.claims.ApproverName = this.approverName;
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo =new MileageInfo();
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo.mileageRate = 0.45;
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo.mileageRateFor =this.translate.instant('label_four_wheeler');
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo.fMVehicleType = 1;
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo.mileageUOM = 1;
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo.mileageRateFor4Wheeler = 0.45;
    this.organisationBasicSetup.RequestInfo.setUpInfo.mileageInfo.mileageRateFor2Wheeler = 0.25;
    this.organisationBasicSetup.RequestInfo.setUpInfo.profileInfo =new Profileinfo();
    this.organisationBasicSetup.RequestInfo.setUpInfo.profileInfo.organisationName =this.claims.OrgName;
    this.organisationBasicSetup.RequestInfo.setUpInfo.profileInfo.claimantRangeMasterId =this.claims.ClaimantRangeMasterId;
    this.organisationBasicSetup.RequestInfo.setUpInfo.profileInfo.phoneNumber =this.claims.PhoneNumber;

    this.claims.OrganisationBasicSetup = JSON.stringify(
      this.organisationBasicSetup
    );
    this.claimsService.updateClaims(this.claims);
    this.authenticationService.organisationBasicSetup(this.organisationBasicSetup, this.claims.Token)
      .subscribe(
        (data:any) => {
          if (data.statusCode == 0) {
            this.claims.UserId = data.responseInfo.userId;
            this.claims.EmailId = data.responseInfo.emailId;
            this.claims.IsMarqueeOn = data.responseInfo.isMarqueeOn;
            this.claims.MarqueeText = data.responseInfo.marqueeText;
            this.claimsService.updateClaims(this.claims);

            this.authenticationService.organisationdetails(
                data.responseInfo.userId.toString(),
                data.responseInfo.emailId,
                this.claims.Token
              )
              .subscribe((orgData:any) => {
                if (orgData.statusCode == 0) {
                  this.claims.OrgId = orgData.responseInfo[0].orgId;
                  // keep buttons disabled here — success navigates away via goToNextStep()
                  this.claims.CompanyApproverRule =orgData.responseInfo[0].companyApproverRule;
                  this.claims.isUniversalImportAllowed =orgData.responseInfo[0].isUniversalImportAllowed;
                  this.claims.RateType = orgData.responseInfo[0].rateType;
                  this.claims.IsAPAutomationAllow =orgData.responseInfo[0].isAPAutomationAllow;                    
                  this.claims.BandId = orgData.responseInfo[0].bandId;
                  this.claims.BandPlanId = orgData.responseInfo[0].bandPlanId;
                  this.claims.BillingCycle = orgData.responseInfo[0].billingCycle;
                  this.claims.TwoStepApproval =orgData.responseInfo[0].twoStepApproval;
                  this.claims.isClaimOnWebAllowed = orgData.responseInfo[0].isClaimOnWebAllowed;
                  this.claims.orgRoleId = orgData.responseInfo[0].roleId;
                  this.claims.IsContainerAllowed = orgData.responseInfo[0].isContainerAllowed;
                  this.claims.IsSelfSetupOn = orgData.responseInfo[0].isSelfSetupOn;
                  this.claimsService.updateClaims(this.claims);
                  this.oauthService.fetchTokenUsingPasswordFlowAndLoadUserProfile(
                      this.claims.LoginId,
                      "testpassword"
                    )
                    .then(() => {
                      this.ngxService.stop();
                     this.goToNextStep();
                    })
                    .catch((err) => {
                      console.error("error logging in", err);
                      this.fnReleaseSubmitting();
                    });
                } else {
                  this.fnReleaseSubmitting();
                }
              },
              () => {
                this.fnReleaseSubmitting();
              });
          } else {
            this.fnReleaseSubmitting();
          }
        },
        (error:any) => {
          this.fnReleaseSubmitting();
        }
      );
  }

  bindVersionHistory() {
    if (!this.claims.appVersion) {
      this.versionHistoryService.getVersionHistory().subscribe((res: any) => {
        if (res.statusCode == 0) {
          let currentVersion = res.responseInfo.filter(
            (x: any) => x.isCurrentRelease
          )[0].versionNumber;

          this.claims.appVersion = currentVersion;
          this.claimsService.updateClaims(this.claims);
        }
      });
    }
  }

  allowAcuteCharFN(e: any) {
    if (!this.isSubmitting) {
      this.IsInviteCanBeDisabled = false;
      this.continueConfig = {...this.continueConfig,  disabled: this.isContinueDisabled || this.IsInviteCanBeDisabled,};
    }
    let regex = new RegExp("^[a-zA-ZÀ-úp{L} '-]+$");
    let str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      this.currentEmpFN = '';
      this.accEmpFN = '';
      this.firstnameConfig = {
        ...this.firstnameConfig,
        isInvalid: false,
        helperText: ''
      };
      this.firstAccnameConfig = {
        ...this.firstAccnameConfig,
        isInvalid: false,
        helperText: ''
      };
      return true;
    }     
      if(e.currentTarget.id.includes("accordion")){
        this.accEmpFN = this.translate.instant('numeric_keys_not_allowed');
        this.firstAccnameConfig = {
          ...this.firstAccnameConfig,
          isInvalid: true,
          helperText: this.accEmpFN
        };
      } 
      else{
        this.currentEmpFN = this.translate.instant('numeric_keys_not_allowed');
        this.firstnameConfig = {
          ...this.firstnameConfig,
          isInvalid: true,
          helperText: this.currentEmpFN
        };
      }
      return false;
  }

  allowAcuteCharLN(e: any) {
    if (!this.isSubmitting) {
      this.IsInviteCanBeDisabled = false;
      this.continueConfig = {...this.continueConfig,  disabled: this.isContinueDisabled || this.IsInviteCanBeDisabled,};
    }
    let regex = new RegExp("^[a-zA-ZÀ-úp{L} '-]+$");
    let str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      this.currentEmpLN = '';
      this.accEmpLN = '';
      this.lastnameConfig = {
        ...this.lastnameConfig,
        isInvalid: false,
        helperText: ''
      };
      this.lastaccnameConfig = {
        ...this.lastaccnameConfig,
        isInvalid: false,
        helperText: ''
      };
      return true;
    }     
      if(e.currentTarget.id.includes("accordion")){
        this.accEmpLN = this.translate.instant('numeric_keys_not_allowed');
        this.lastaccnameConfig = {
          ...this.lastaccnameConfig,
          isInvalid: true,
          helperText: this.accEmpLN
        };
      }
      else{
        this.currentEmpLN = this.translate.instant('numeric_keys_not_allowed');
        this.lastnameConfig = {
          ...this.lastnameConfig,
          isInvalid: true,
          helperText: this.currentEmpLN
        };
      }
      return false;
  }

  async validateAllInvitesWithObjects(): Promise<boolean> {
    for (let i = 0; i < this.invitedEmployees.length; i++) {
      const userExists = await this.validateAllInvites(this.invitedEmployees[i], i);
      if (userExists || this?.accEmpEmail || this?.accEmpFN) {
        return false;
      }
    }
    return true;
  }

  async validateAllInvites(newAttributeObj: any, index: number): Promise<boolean> {
    try {
      const userData: any = await lastValueFrom(
        this.authenticationService.checkForUserExistance(newAttributeObj.email).pipe(first())
      );
      
      if (userData.responseInfo != null && newAttributeObj.email != this.claims.EmailId) {
        this.toggleAccordion(index);
        this.accEmpEmail = this.translate.instant('claimant_exists');
        this.emailaccConfig = {
          ...this.emailaccConfig,
          isInvalid: true,
          helperText: this.accEmpEmail
        };
        return true;
      }
      else if(this.accEmpEmail === this.translate.instant('claimant_exists')){
         this.accEmpEmail = '';
         this.emailaccConfig = {
           ...this.emailaccConfig,
           isInvalid: false,
           helperText: ''
         };
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  goToNextStep() {
      this.gotoNextStepEvent.emit(7);
    }
}
